import { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { DeviceStatus } from "components/DeviceStatus";
import { DeviceHistory } from "components/DeviceHistory";
import { DeviceCharts } from "components/DeviceCharts";
import { DeviceConfig } from "components/DeviceConfig";
import DeviceUsers from "./users/DeviceUsers";
import DeviceAlarms from "components/DeviceAlarms";
import { TabsContainer } from "styles/devices/deviceDetails.styles";
import { DeviceRegion } from "types/device.types";
import { useAuth } from "context/AuthContext";
import { useDevice } from "hooks/useDevices";

interface DeviceTabsProps {
  serialNumber: string;
  region: DeviceRegion;
  linkId?: string;
}

function DeviceTabs({ serialNumber, region, linkId }: DeviceTabsProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const { user } = useAuth();
  const isAdmin = user?.role === "ADMIN";
  const { data: deviceData } = useDevice(serialNumber, linkId);
  const deviceId = deviceData?.id;

  return (
    <TabsContainer>
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <TabPanel header="Device Status" leftIcon="pi pi-cog">
          <DeviceStatus serialNumber={serialNumber} region={region} />
        </TabPanel>

        <TabPanel header="Charts" leftIcon="pi pi-chart-bar">
          <DeviceCharts serialNumber={serialNumber} />
        </TabPanel>

        <TabPanel header="Alarms" leftIcon="pi pi-exclamation-triangle">
          <DeviceAlarms serialNumber={serialNumber} />
        </TabPanel>

        <TabPanel header="History" leftIcon="pi pi-history">
          <DeviceHistory serialNumber={serialNumber} />
        </TabPanel>

        <TabPanel header="Configuration" leftIcon="pi pi-sliders-h">
          <DeviceConfig serialNumber={serialNumber} linkId={linkId} />
        </TabPanel>

        {isAdmin && deviceId && (
          <TabPanel header="Users" leftIcon="pi pi-users">
            <DeviceUsers serialNumber={serialNumber} deviceId={deviceId} />
          </TabPanel>
        )}
      </TabView>
    </TabsContainer>
  );
}

export default DeviceTabs;
